<template>
    <nav class="navbar is-flex is-justify-content-space-between is-align-items-center py-5" role="navigation"
         aria-label="main navigation">
        <HeaderItem>
            <div v-if="showStepsAndBackButton" class="back-button" @click="goBack()"></div>
        </HeaderItem>
        <HeaderItem class="register-header-logo" justify="center" @click="goToHome()">
            <img src="@/assets/images/logo_temp.svg" alt="gourmetta logo">
        </HeaderItem>
        <HeaderItem>
            <Step v-if="showStepsAndBackButton" :actual-step="step" :max-step="maxStepToDisplay"/>
        </HeaderItem>
    </nav>
</template>

<script>
import HeaderItem from "@/views/components/ui/Register/Header/HeaderItem";
import Step from "@/views/components/ui/Register/Header/Step";

export default {
    name: 'RegisterHeader',
    components: {
        HeaderItem,
        Step
    },
    emits: ['goBack'],
    props: {
        step: {
            type: Number,
            required: false
        },
        maxStepToDisplay: {
            type: Number,
            required: false
        }
    },
    computed: {
        showStepsAndBackButton()  {
            return typeof this.step === 'number'
                && typeof this.maxStepToDisplay === 'number'
                && this.step <= this.maxStepToDisplay;
        }
    },
    methods: {
        goBack() {
            this.$emit('goBack');
        },
        goToHome() {
            this.$router.push({name: 'Home'})
        }
    },
}
</script>

<style lang="scss">
.navbar {
    padding-left: $gap;
    padding-right: $gap;
    box-shadow: 0 0 $shadow-blur $shadow-color;

    .back-button:after {
        border: 3px solid $primary;
        border-right: 0;
        border-top: 0;
        content: " ";
        display: block;
        height: 0.625em;
        margin-top: -0.4375em;
        position: absolute;
        transform: rotate(45deg);
        width: 0.625em;
        cursor: pointer;
    }

    .register-header-logo {
        img {
            max-height: 3em;
        }
        cursor: pointer;
    }

}
</style>
